(() => {
  // src/scripts/scroll-animations.js
  var ScrollAnimations = class {
    constructor() {
      this.animatedElements = /* @__PURE__ */ new Set();
      this.observer = null;
      this.init();
    }
    init() {
      this.observer = new IntersectionObserver(
        (entries) => this.handleIntersection(entries),
        {
          threshold: 0.1,
          rootMargin: "0px 0px -50px 0px"
        }
      );
      this.observeElements();
      this.setupMutationObserver();
    }
    observeElements() {
      const elements = document.querySelectorAll("[data-animate]");
      elements.forEach((element) => {
        if (!this.animatedElements.has(element)) {
          this.observer.observe(element);
          element.classList.add("animate-hidden");
        }
      });
    }
    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.animatedElements.has(entry.target)) {
          this.animateElement(entry.target);
          this.animatedElements.add(entry.target);
          this.observer.unobserve(entry.target);
        }
      });
    }
    animateElement(element) {
      const animationType = element.dataset.animate;
      const delay = element.dataset.delay || 0;
      setTimeout(() => {
        element.classList.remove("animate-hidden");
        element.classList.add("animate-visible", `animate-${animationType}`);
      }, parseInt(delay));
    }
    setupMutationObserver() {
      const mutationObserver = new MutationObserver(() => {
        this.observeElements();
      });
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    // Public method to manually trigger animations
    refresh() {
      this.observeElements();
    }
  };
  document.addEventListener("DOMContentLoaded", () => {
    window.scrollAnimations = new ScrollAnimations();
  });
  document.addEventListener("shopify:section:load", () => {
    if (window.scrollAnimations) {
      window.scrollAnimations.refresh();
    }
  });

  // src/scripts/main.js
  document.addEventListener("DOMContentLoaded", function() {
    console.log("Theme loaded");
    initializeCart();
    initializeMobileMenu();
  });
  function initializeCart() {
    const cartForms = document.querySelectorAll('form[action*="cart/add"]');
    cartForms.forEach((form) => {
      form.addEventListener("submit", function(e) {
        e.preventDefault();
        const formData = new FormData(form);
        const button = form.querySelector('button[type="submit"]');
        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = "Adding...";
        fetch("/cart/add.js", {
          method: "POST",
          body: formData
        }).then((response) => response.json()).then((data) => {
          button.textContent = "Added!";
          updateCartCount();
          setTimeout(() => {
            button.disabled = false;
            button.textContent = originalText;
          }, 2e3);
        }).catch((error) => {
          console.error("Error adding to cart:", error);
          button.disabled = false;
          button.textContent = originalText;
        });
      });
    });
  }
  function updateCartCount() {
    fetch("/cart.js").then((response) => response.json()).then((cart) => {
      const cartCount = document.querySelector(".cart-count");
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        cartCount.style.display = cart.item_count > 0 ? "flex" : "none";
      }
    }).catch((error) => console.error("Error updating cart count:", error));
  }
  function initializeMobileMenu() {
  }
})();
